import { detect } from 'detect-browser';

export const deviceInfo = (fcmToken) => {
  if (fcmToken === null) {
    return {};
  }
  const browser = detect();
  return {
    device: {
      fcmToken,
      name: browser.name,
      family: browser.os,
    },
  };
};

export const browserInfo = () => {
  const browser = detect();
  return {
    name: browser.name,
    family: browser.os,
  };
};



// WEBPACK FOOTER //
// ./scripts/modules/browserDetect.js